import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Analytics = Loadable(lazy(() => import('./ProductSection')));
const ProductList = Loadable(lazy(() => import('./ProductList')));
const ProductEditList = Loadable(
	lazy(() => import('../../form/EditProductForm')),
);

const ProductRoutes = [
	{
		path: '/package/add',
		element: <Analytics />,
		auth: authRoles.admin,
	},
	{
		path: '/package/list',
		element: <ProductList />,
		auth: authRoles.admin,
	},
	{
		path: '/package/edit',
		element: <ProductEditList />,
		auth: authRoles.admin,
	},
];

export default ProductRoutes;
